function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u5BA2\\u6237\\u6807\\u7B7E",
  transform: "translate(-1072.000000, -103.000000)",
  fill: "#BDBDBD",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "\\u641C\\u7D22",
  transform: "translate(1058.000000, 92.000000)"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-35"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-29",
  transform: "translate(14.000000, 11.000000)"
}, React.createElement("path", {
  d: "M6.20588745,0 C9.63330445,0 12.4117749,2.77847045 12.4117749,6.20588745 C12.4117749,7.5457881 11.9871386,8.78650963 11.265099,9.80081914 L13.6970563,12.2343146 C14.1009812,12.6382395 14.1009812,13.2931313 13.6970563,13.6970563 C13.2931313,14.1009812 12.6382395,14.1009812 12.2343146,13.6970563 L9.80081914,11.265099 C8.78650963,11.9871386 7.5457881,12.4117749 6.20588745,12.4117749 C2.77847045,12.4117749 0,9.63330445 0,6.20588745 C0,2.77847045 2.77847045,0 6.20588745,0 Z M6.20588745,2.06862915 C3.92094279,2.06862915 2.06862915,3.92094279 2.06862915,6.20588745 C2.06862915,8.49083212 3.92094279,10.3431458 6.20588745,10.3431458 C8.49083212,10.3431458 10.3431458,8.49083212 10.3431458,6.20588745 C10.3431458,3.92094279 8.49083212,2.06862915 6.20588745,2.06862915 Z",
  id: "\\u5F62\\u72B6"
}))))));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.86043a1e.svg";
export { ForwardRef as ReactComponent };